globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Emailing = appCustomerSpace.Controllers.Emailing || {};

appCustomerSpace.Controllers.Emailing.DeliveriesController = (function (superClass) {

  utils.extend(DeliveriesController, superClass);

  function DeliveriesController() {
    return DeliveriesController.__super__.constructor.apply(this, arguments);
  }

  $.extend(DeliveriesController.prototype, {
    init: function () {
      this.$body.on('click', '.reschedule-button', function(e) {
        e.preventDefault();
        var $button = $(this);
        var $form = $button.closest('form');

        $.post($form.attr('action'), $form.serialize(), function(data) {
          if(data.response) {
            $button.attr("disabled", true);
            $button.find("i").addClass("spinner")
            if ($button.hasClass("reschedule-all-button")) {
              $("button.reschedule-button.schedulable").attr("disabled", true);
              $("button.reschedule-button.schedulable").find("i").addClass("spinner");
            }
          }
        });
      });
      return DeliveriesController.__super__.init.apply(this, arguments);
    },
  });

  return DeliveriesController;

})(appCustomerSpace.Controllers.Emailing.MainController);
